import AuthService from '@app/services/authService'
import { useMutation } from '@tanstack/react-query'
import { toast } from '@app/components/ui/Toast/toast'

type TermsAndConditionsFormProps = {
  user_info: {
    user_uuid: string
    client_name: string
  }
}

export const useTermsAndConditions = () => {
  return useMutation({
    mutationFn: ({ user_info }: TermsAndConditionsFormProps) =>
      AuthService.accept_terms({ user_info }),
    onSuccess: () => {
      // TODO: Move fetching user profile to tansrack query hook so we can just invalidate here
      toast({
        type: 'success',
        description: 'Terms and Conditions accepted successfully',
        position: 'top-center',
      })
    },
    onError: (error) => {
      toast({
        type: 'error',
        description:
          error.message || 'An error occurred accepting Terms and Conditions. Please try again.',
        position: 'top-center',
      })
    },
  })
}
